/* Lilibloom period-page sections · shared runtime.
   Every lb-* section includes this file; the guard makes sure it only runs once.
   LB.ready(fn) calls fn(gsap, ScrollTrigger) once GSAP is loaded, or fn(null) when the
   visitor prefers reduced motion or GSAP failed to load. */
(function () {
  if (window.LB) return;

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var queue = [];
  var state = reduce ? 'off' : 'loading';

  function flush() {
    var g = state === 'on' ? window.gsap : null;
    var st = state === 'on' ? window.ScrollTrigger : null;
    document.documentElement.classList.add('lb-motion-done');
    queue.splice(0).forEach(function (fn) {
      try { fn(g, st); } catch (e) { console.error(e); }
    });
  }

  function load(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src; s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  window.LB = {
    reduce: reduce,
    isMobile: function () { return matchMedia('(max-width: 900px)').matches; },
    ready: function (fn) {
      queue.push(fn);
      if (state !== 'loading') flush();
    }
  };

  var me = document.currentScript;
  if (state === 'loading' && me) {
    var base = me.src.replace(/lb-core\.js.*$/, '');
    var q = me.src.split('?')[1];
    var suffix = q ? '?' + q : '';
    (window.gsap ? Promise.resolve() : load(base + 'lb-gsap.min.js' + suffix))
      .then(function () { return window.ScrollTrigger ? null : load(base + 'lb-scrolltrigger.min.js' + suffix); })
      .then(function () { gsap.registerPlugin(ScrollTrigger); state = 'on'; flush(); })
      .catch(function () { state = 'off'; flush(); });
  } else {
    state = 'off';
    flush();
  }
})();
